"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs = __importStar(require("query-string"));
var Deferred_1 = require("./Deferred");
var Keycat = /** @class */ (function () {
    function Keycat(config) {
        var _this = this;
        this.getKeycatOrigin = function () {
            var defaultOrigin = "https://{{NAME}}.keycat.co";
            var _a = _this.config, _b = _a.blockchain, name = _b.name, network = _b.network, __keycatOrigin = _a.__keycatOrigin;
            if (__keycatOrigin) {
                return __keycatOrigin;
            }
            var subdomain = [name, network]
                .filter(Boolean)
                .join('-')
                .replace('-main', '');
            return defaultOrigin.replace('{{NAME}}', subdomain);
        };
        this.buildSrc = function (path, args) {
            if (args === void 0) { args = []; }
            var client = location.origin;
            var blockchain = _this.config.blockchain;
            var search = qs.stringify({
                blockchain: JSON.stringify(blockchain),
                client: client,
                account: _this.currentAccount,
                payload: _this.encode(args),
            });
            return _this.keycatOrigin + path + ("?" + search);
        };
        this.open = function (src) {
            var deferred = new Deferred_1.Deferred();
            _this.openPopup(src, deferred);
            window.onmessage = function (_a) {
                var data = _a.data;
                var ____keycat = data.____keycat;
                if (!____keycat)
                    return;
                _this.respond(data, deferred);
            };
            return deferred.promise;
        };
        this.openPopup = function (src, deferred) {
            if (_this.popup) {
                _this.popup.close();
            }
            var w = 420;
            var h = 720;
            var y = window.top.outerHeight / 2 + window.top.screenY - h / 2;
            var x = window.top.outerWidth / 2 + window.top.screenX - w / 2;
            var opts = ["width=" + w, "height=" + h, "top=" + y, "left=" + x].join(',');
            _this.popup = window.open(src, 'Keycat', opts);
            var timer = setInterval(function () {
                if (_this.popup.closed) {
                    clearInterval(timer);
                    deferred.reject('CLOSED');
                }
            }, 500);
        };
        this.respond = function (response, promise) {
            var type = response.type, payload = response.payload;
            if (type === 'close') {
                promise.reject('CLOSED');
            }
            else {
                var data = payload.data, error = payload.error;
                if (error)
                    promise.reject(error);
                if (data)
                    promise.resolve(data);
            }
            _this.popup.close();
            // this.closeIframe()
        };
        this.guardAccountAction = function (methodName) {
            if (!_this.currentAccount) {
                throw new Error("You must chain key like this. keycat.account('...').[" + methodName + "](...) ");
            }
        };
        this.encode = function (data) {
            return encodeURIComponent(btoa(JSON.stringify(data)));
        };
        this.account = function (account) {
            _this.currentAccount = account;
            return _this;
        };
        this.signin = function () {
            var a = 'asdfs';
            return _this.open(_this.buildSrc('/signin'));
        };
        this.signTransaction = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.guardAccountAction('signTransaction');
            return _this.open(_this.buildSrc('/sign-transaction', args));
        };
        this.signArbitraryData = function (data) {
            _this.guardAccountAction('signArbitraryData');
            return _this.open(_this.buildSrc('/sign-arbitrary-data', data));
        };
        this.transact = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.guardAccountAction('transact');
            var src = _this.buildSrc('/transact', args);
            return _this.open(src);
        };
        this.config = config;
        this.keycatOrigin = this.getKeycatOrigin();
    }
    return Keycat;
}());
exports.default = Keycat;
